const voidResolver = () => undefined

export { voidResolver }
